export const accountModuleValueMap = {
  // news: 3,
  // users: 4,
  // shifts: 5,
  // rosters: 6,
  // timesheets: 7,
  // availability: 8,
  // account: 9,
  // teams: 10,
  // insights: 11,
  // reports: 12,
  // calendar: 13,
  // exchange: 14,
  // absence: 15,
  // 'app center': 16,
  minijob: 17,
  chat: 18,
  chatOptIn: 19,
} as const;

export type AccountModuleKey = keyof typeof accountModuleValueMap;
export type AccountModuleId = (typeof accountModuleValueMap)[AccountModuleKey];

export interface AccountModuleToggle {
  id: AccountModuleId;
  enabled: boolean;
}
